import { render, staticRenderFns } from "./KnowledgeProcessingModal.vue?vue&type=template&id=33558a06&"
import script from "./KnowledgeProcessingModal.vue?vue&type=script&lang=js&"
export * from "./KnowledgeProcessingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33558a06')) {
      api.createRecord('33558a06', component.options)
    } else {
      api.reload('33558a06', component.options)
    }
    module.hot.accept("./KnowledgeProcessingModal.vue?vue&type=template&id=33558a06&", function () {
      api.rerender('33558a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/knowledgeBase/KnowledgeProcessingModal.vue"
export default component.exports